/* eslint-disable */
export default {
  DirectNumber: 'Direct',
  MainCompanyNumber: 'Primair',
  CompanyNumber: 'Bedrijf',
  CompanyFaxNumber: 'Fax',
  Blocked: 'Geblokkeerd',
  AdditionalCompanyNumber: 'Bedrijf',
  ForwardedCompanyNumber: 'Doorgeschakeld',
  from: 'Van',
} as const;

// @key: @#@"DirectNumber"@#@ @source: @#@"Direct"@#@
// @key: @#@"MainCompanyNumber"@#@ @source: @#@"Main"@#@
// @key: @#@"CompanyNumber"@#@ @source: @#@"Company"@#@
// @key: @#@"CompanyFaxNumber"@#@ @source: @#@"Fax"@#@
// @key: @#@"Blocked"@#@ @source: @#@"Blocked"@#@
// @key: @#@"AdditionalCompanyNumber"@#@ @source: @#@"Company"@#@
// @key: @#@"ForwardedCompanyNumber"@#@ @source: @#@"Forwarded"@#@
// @key: @#@"from"@#@ @source: @#@"From"@#@
